import ListCategories from "../../../../components/@products/categories/ListCategories";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CategoriesPage() {

    return (
        <ListCategories 
            routeType={routeTypes.admin}
        />
    )
}